var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-wrapper',{attrs:{"width":"600","hide-logo":true}},[(_vm.user)?_c('div',{attrs:{"id":"debuggerOutput"}},[_c('json-viewer',{attrs:{"value":{userinfo: _vm.user.profile,
                jwt_access_token: _vm.parseJwt(_vm.user.access_token),
                jwt_id_token: _vm.parseJwt(_vm.user.id_token)},"expand-depth":5}}),_c('json-viewer',{attrs:{"value":{access_token: _vm.user.access_token},"expand-depth":1,"preview-mode":true,"copyable":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }